import { Component, Input } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { InTransitCallsResponse } from '../../../models/responses/intransit-call-response';
import { MatDialog } from '@angular/material/dialog';
import { AutoCallBackSettingsComponent } from '../integration-components/auto-call-back-action-settings/auto-call-back-action-settings.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-missed-outbound-calls',
  standalone: true,
  imports: [MatTableModule, MatPaginatorModule, MatIconModule, NgIf, MatIconModule, MatButtonModule],
  templateUrl: './missed-outbound-calls.component.html',
  styleUrl: './missed-outbound-calls.component.scss'
})
export class MissedOutboundCallsComponent {

  @Input() aiAgent!: AiAgentResponse;
  displayedColumns: string[] = ['Target phone number', 'Created', 'Auto CallBack Scheduled Date'];
  dataSource!: MatTableDataSource<InTransitCallsResponse>;
  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    console.log(this.aiAgent)
    this.dataSource = new MatTableDataSource();
    this.initTableData();
  }

  initTableData() {
    this.dataSource.data = this.aiAgent.outBoundSettings?.inTransitCalls || [];
  }

  onConfigureAutoCallBack() {
    this.dialog.open(AutoCallBackSettingsComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.aiAgent, missedCallSettings: this.aiAgent.outBoundSettings?.autoCallbackSettings }
    }).afterClosed().subscribe(data => {
      if (this.aiAgent.outBoundSettings) {
        if (data && data.deleted) {
          this.aiAgent.outBoundSettings.autoCallbackSettings = undefined;
        } else {
          this.aiAgent.outBoundSettings.autoCallbackSettings = data?.missedCallSettings || this.aiAgent.outBoundSettings?.autoCallbackSettings
        }
      }
    })
  }
}
